module.exports = global["pdfMake"] = require("-!./pdfMake.js");


//////////////////
// WEBPACK FOOTER
// ./src/browser-extensions/pdfMake.js-exposed
// module id = 122
// module chunks = 0 1